import './ShowMoreTypeLabel.scss';

import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { AccessType, DataAccessTypePlural } from '@sonar-software/sonar-core';

export type ShowMoreTypeLabelProps = {
	allowShowMore: boolean;
	onClick: (info: AccessType | undefined) => void;
	type: AccessType;
};

export const ShowMoreTypeLabel: React.FC<ShowMoreTypeLabelProps> = ({
	allowShowMore,
	onClick,
	type
}) =>
	<div
		className='data-access-type-label'
		key={ type }>
		<span>{ DataAccessTypePlural[ type ] }</span>
		{ allowShowMore &&
			<span
				className='show-more-link'
				onClick={ () => onClick(type) }>
				{ COPY_GENERIC.SHOW_MORE }
			</span> }
	</div>;
